import { Card } from "@biteship/atom";
import { isAuthenticated } from "store/action/auth";
import { formatTime, formatDate } from "services/helpers/formatter";
import DOMPurify from "dompurify";

export default function MessageCard(props) {
  const { user } = isAuthenticated();

  const sanitizedComment = DOMPurify.sanitize(props?.comment?.content || "")
    .replace(/<p>/g, "<p class='mb-0' >") // p tag is styled with bottom margin globally, but the content here, each line is using p tag
    .replace(
      /<pre/g,
      `<div class="
        ql-editor
        bg-gray-200
        border
        border-gray-300
        p-2
        rounded
        h-auto
        my-2
      "><pre`
    )
    .replace(/<\/pre>/g, `</pre></div>`)
    .replace(/<img/g, `<img style="max-height: 200px;"`);

  return (
    <Card className="px-5 py-4 border">
      {!!props?.comment?.self ? (
        <div className="text-gray-900 font-bold text-sm">
          {user.firstName} {user.lastName}
        </div>
      ) : props?.comment?.userRole === "owner" ? (
        <div className="text-primary font-bold text-sm">Customer</div>
      ) : (
        <div className="text-primary font-bold text-sm">
          Biteship - {props.comment.userFirstName} {props.comment.userLastName}
        </div>
      )}
      <div
        className="text-gray-800 mb-2 text-sm p-0 ql-editor"
        dangerouslySetInnerHTML={{ __html: sanitizedComment }}
      ></div>
      <div className="text-gray-700 text-xs">{`${formatDate(props.comment.updatedAt)}, ${formatTime(
        props.comment.updatedAt
      )}`}</div>
    </Card>
  );
}
